export const ItemTypes = {
  SCHOOL: "school"
};

export const CARD_WIDTH = 408;
